import { OrderStatus, ScheduledActionEnumAction } from '@wix/ambassador-events-v1-order/types';
import { ticketsHaveSeatInfo } from './ticket';
export const isUnpaidOrder = (order) => isUnpaidOrderStatus(order?.status);
export const isUnpaidOrderStatus = (orderStatus) => orderStatus !== OrderStatus.PAID && orderStatus !== OrderStatus.FREE && orderStatus !== OrderStatus.VOIDED;
export const orderHasSeating = (order) => (order?.tickets ? ticketsHaveSeatInfo(order?.tickets) : false);
export const isOrderPending = (order) => order?.status === OrderStatus.PENDING;
export const isOrderAuthorized = (order) => order?.status === OrderStatus.AUTHORIZED;
export const isOrderVoided = (order) => order?.status === OrderStatus.VOIDED;
export const isOrderFree = (order) => order?.status === OrderStatus.FREE;
export const isOrderPaid = (order) => order?.status === OrderStatus.PAID;
export const isOrderEligibleForInvoice = (order) => Boolean(order?.contactId);
export const isOrderDeclined = (order) => order?.status === OrderStatus.DECLINED || order?.status === OrderStatus.VOIDED;
export const isOrderAutoVoid = (order) => isOrderAuthorized(order) && order.paymentDetails?.transaction?.scheduledAction === ScheduledActionEnumAction.VOID;
export const orderHasEmail = (order) => Boolean(order?.email);
export const getOrderGiftCardsTotalAmount = (giftCardPaymentDetails) => giftCardPaymentDetails?.length
    ? giftCardPaymentDetails.reduce((total, details) => total + Number(details.amount.amount), 0)
    : 0;
export const getOrderCompletePaymentMethodTitle = (order, paymentMethod, otherPaymentMethodTitle, giftCardTitle) => {
    const paymentMethodTitle = paymentMethod || otherPaymentMethodTitle;
    return !order.giftCardPaymentDetails?.length
        ? paymentMethodTitle
        : getOrderGiftCardsTotalAmount(order.giftCardPaymentDetails) === Number(order.invoice.grandTotal.amount)
            ? giftCardTitle
            : `${paymentMethodTitle}/${giftCardTitle}`;
};
//# sourceMappingURL=order.js.map